import {Country} from "../../../region/types/Country";
import {IOfferGroupsSimplified} from "../../detail/types/IOfferGroups";
import {OfferDisplayType} from "../../helpers/OfferDisplayType";
import {ISalesOffice} from "../../types/ISalesOffice";
import {OfferPriceType} from "../../types/OfferPriceType";
import {OfferType} from "../../types/OfferType";

export interface IModalPropertyListOffer {
    address: string;
    configuration: {
        display_type: OfferDisplayType;
        hide_properties_prices_for_anonymous_users: boolean;
        is_autoresponder_enabled: boolean;
        limited_presentation?: boolean;
        phone_clip: string | null;
        personal_data_processor_name: string | null;
        personal_data_processor_url: string | null;
        privacy_policy_url: string | null;
    };
    has_active_promotions: boolean;
    has_required_prices: boolean | null;
    geo_point: {
        coordinates: [number, number];
    };
    id: number;
    is_active?: boolean;
    is_holiday_location: boolean;
    name: string;
    is_phone_clip_enabled: boolean;
    region: {
        country: Country;
        id: number;
        full_name: string;
    };
    sales_offices: ISalesOffice[];
    stats: {
        properties_with_roi_count: number;
        properties_count_for_sale: number;
    } | null;
    price_type?: OfferPriceType | null;
    slug: string;
    type: OfferType;
    vendor: {
        configuration: {
            privacy_policy_url?: string | null;
            privacy_policy_file?: string | null;
        };
        id: number;
        logo_url: string | null;
        name: string;
        offices?: {
            address: string;
            phone: string;
            mobile: string;
            type: number;
            region: {
                id: number;
                short_name: string;
            };
        }[];
        slug: string;
    };
    groups: IOfferGroupsSimplified | null;
}

export const DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE = 20;
import {Country} from "../../../region/types/Country";
import {IOfferGroupsSimplified} from "../../detail/types/IOfferGroups";
import {OfferDisplayType} from "../../helpers/OfferDisplayType";
import {ISalesOffice} from "../../types/ISalesOffice";
import {OfferPriceType} from "../../types/OfferPriceType";
import {OfferType} from "../../types/OfferType";

export interface IModalPropertyListOffer {
    address: string;
    configuration: {
        display_type: OfferDisplayType;
        hide_properties_prices_for_anonymous_users: boolean;
        is_autoresponder_enabled: boolean;
        limited_presentation?: boolean;
        phone_clip: string | null;
        personal_data_processor_name: string | null;
        personal_data_processor_url: string | null;
        privacy_policy_url: string | null;
    };
    has_active_promotions: boolean;
    has_required_prices: boolean | null;
    geo_point: {
        coordinates: [number, number];
    };
    id: number;
    is_active?: boolean;
    is_holiday_location: boolean;
    name: string;
    is_phone_clip_enabled: boolean;
    region: {
        country: Country;
        id: number;
        full_name: string;
    };
    sales_offices: ISalesOffice[];
    stats: {
        properties_with_roi_count: number;
        properties_count_for_sale: number;
    } | null;
    price_type?: OfferPriceType | null;
    slug: string;
    type: OfferType;
    vendor: {
        configuration: {
            privacy_policy_url?: string | null;
            privacy_policy_file?: string | null;
        };
        id: number;
        logo_url: string | null;
        name: string;
        offices?: {
            address: string;
            phone: string;
            mobile: string;
            type: number;
            region: {
                id: number;
                short_name: string;
            };
        }[];
        slug: string;
    };
    groups: IOfferGroupsSimplified | null;
}

export const DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE = 20;
